<script>
import { iIcon } from '@inscribe/signal';
import palette from '@inscribe/signal/dist/palette';

export default {
  components: { iIcon },
  data() {
    return { palette };
  },

  computed: {},
  methods: {
    onButtonClick() {
      this.$emit('on-button-click');
    },
  },
};
</script>

<template>
  <div
    class="right-panel-empty-state d-flex flex-column align-items-center i-p-10 i-gap-6 i-radius-2xl"
  >
    <i-icon
      symbol="medium-user-profile-focus"
      :size="28"
      :colour="palette['light-neutral-90']"
    ></i-icon>
    <div class="text d-flex flex-column i-gap-1 align-items-center">
      <div class="title i-text-button-3 i-text-neutral-120">
        Add documents to get started
      </div>
      <div class="subtitle i-text-button-3 i-text-neutral-110">
        Agent analysis will appear here
      </div>
    </div>
  </div>
</template>
